import { useEffect } from "react";

type SeoProps = {
  title: string;
  description: string;
};

export function Seo({ title, description }: SeoProps) {
  useEffect(() => {
    document.title = `${title} | EdgeLaunch`;

    const ensureMeta = (name: string) => {
      let tag = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
      if (!tag) {
        tag = document.createElement("meta");
        tag.name = name;
        document.head.appendChild(tag);
      }
      return tag;
    };

    const desc = ensureMeta("description");
    desc.content = description;

    const theme = ensureMeta("theme-color");
    theme.content = "#0f766e";
  }, [title, description]);

  return null;
}
